import { useState, useEffect } from 'react';

// Özel React Hook: useDarkMode
export default function useDarkMode() {
  // localStorage'dan başlangıç değerini al veya varsayılan olarak false (açık mod) yap
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('tenantDarkMode'); // tenant specific dark mode key
    return savedMode ? JSON.parse(savedMode) : false;
  });

  // darkMode state'i değiştiğinde localStorage ve HTML etiketinin sınıfını güncelle
  useEffect(() => {
    localStorage.setItem('tenantDarkMode', JSON.stringify(darkMode)); // tenant specific dark mode key
    if (darkMode) {
      document.documentElement.classList.add('dark'); // HTML etiketine 'dark' sınıfını ekle
    } else {
      document.documentElement.classList.remove('dark'); // 'dark' sınıfını kaldır
    }
  }, [darkMode]);

  // Karanlık modu değiştiren fonksiyon
  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  return [darkMode, toggleDarkMode];
}
